module.exports = __webpack_public_path__ + "static/pic03-f2d58d234a9869c9a4cc6ad241a84094.jpg";